"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnknownAggregateLookup = void 0;
const NODE_TYPE = 'UNKNOWN-AGGREGATE-LOOKUP';
const BaseNode_1 = require("../../BaseNode");
const LookupHelper_1 = require("../LookupHelper");
const Schema = __importStar(require("./schema.json"));
const ID_KEY = 'id';
/**
 * the purpose of this node is to provide a way to look up multiple aggregate ids based on the value of a single attribute
 */
class UnknownAggregateLookup extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this.asynchronousResolver = async (nodeMap) => {
            var _a, _b;
            const result = {
                exists: false,
                id: undefined,
                type: undefined,
                primaryLocation: undefined,
                successfulLookup: false,
            };
            const { strategy } = this.config;
            const strategyToUse = strategy || LookupHelper_1.LookupConfigSchema.default;
            if ((0, LookupHelper_1.hasStrategyPreReqs)(strategyToUse, (_a = this.accessorMap) === null || _a === void 0 ? void 0 : _a.ONLINE_ATTRIB_LOOKUP, (_b = this.accessorMap) === null || _b === void 0 ? void 0 : _b.OFFLINE_ATTRIB_LOOKUP)) {
                const inputs = await this.asynchronousResolveInputs(nodeMap);
                const { aggregateId, aggregateTypes } = inputs;
                if (aggregateTypes && aggregateId) {
                    const results = (await Promise.all(aggregateTypes.map((type) => {
                        var _a, _b;
                        return (0, LookupHelper_1.lookupValue)((_a = this.accessorMap) === null || _a === void 0 ? void 0 : _a.ONLINE_ATTRIB_LOOKUP, (_b = this.accessorMap) === null || _b === void 0 ? void 0 : _b.OFFLINE_ATTRIB_LOOKUP, strategyToUse, {
                            aggregateType: type,
                            attributeName: ID_KEY,
                            attributeValue: aggregateId,
                            limit: 1,
                        }).then((result) => ({ [type]: result }));
                    })))
                        // Filter out any empty results
                        .filter((res) => res[Object.keys(res)[0]].results && res[Object.keys(res)[0]].results.length > 0);
                    if (results.length > 0) {
                        const type = Object.keys(results[0])[0]; // the key of the first/probably only result is the type
                        const finalResult = results[0][type].results[0];
                        result.exists = true;
                        result.type = type;
                        result.id = finalResult.id;
                        result.successfulLookup = results[0][type].lookupSucceeded;
                        // We know that primaryLocation will be a string at this point...I think
                        result.primaryLocation = finalResult.primaryLocation;
                    }
                }
            }
            // Accessor was not available, can not run this transform
            return result;
        };
        this.synchronousResolver = (_nodeMap) => {
            throw new Error('Unknown Aggregate Lookup is not allowed as a synchronously resolving node');
        };
        //TODO: Build the interface definition from the given schema....but what is our schema
        this._interfaceDefinition = Schema;
    }
    // we override the schema definition here so that we can provide it based on the selected value
    get interfaceDefinition() {
        //grab the available aggregate types if available
        const aggregateTypes = this.schemaLookup.getAggregates && this.schemaLookup.getAggregates();
        // grab the available event schemas
        //set up the basic outputParams schema
        const InputParams = {
            type: 'object',
            properties: {
                aggregateTypes: { type: 'array', items: { type: 'string', enum: aggregateTypes } },
                aggregateId: { type: 'string' },
            },
        };
        return Object.assign(Object.assign({}, Schema), { InputParams: InputParams, OutputParams: this._interfaceDefinition.definitions.OutputParams, ConfigParams: {
                type: 'object',
                properties: {
                    strategy: LookupHelper_1.LookupConfigSchema,
                },
            } });
    }
}
exports.UnknownAggregateLookup = UnknownAggregateLookup;
UnknownAggregateLookup._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Unknown Aggregate Lookup',
    isIdempotent: false,
    primaryCategory: 'Data Lookup',
};
//# sourceMappingURL=UnknownAggregateLookup.js.map